export default __webpack_public_path__ + "static/media/ic-person-purple.d0e2e052.svg";